<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="معلومات البرنامج"
    footer-class="removed"
    id="programModal"
    class="edit-modal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="programValidation">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <form-input rules="required" label="الاسم" v-model="form.name" />
            </b-col>

            <b-col cols="12">
              <form-select
                multiple
                rules="required"
                label="الفئات المستهدفة"
                id="ageCategory"
                v-model="form.category_ids"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                ep="/v2/selects/age-categories"
                :closeOnSelect="false"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                multiple
                rules="required"
                label="الخدمات"
                id="services"
                v-model="form.service_ids"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name_ar"
                ep="/v2/selects/ngo-related-services"
                :closeOnSelect="false"
              />
            </b-col>
            <b-col cols="12">
              <form-textarea
                rules="required"
                label="الأهداف"
                v-model="form.objectives"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              @click="onSubmit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formInput from "@/components/form-input";
import formSelect from "@/components/form-select";
import vSelect from "vue-select";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import { required, integer } from "@validations";

const initForm = {
  name: "",
  objectives: "",
  category_ids: [],
};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      options: [
        { id: "مرتبط بالخطة", name: "مرتبط بالخطة" },
        { id: "طارئ", name: "طارئ" },
      ],
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.programValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
